import React from "react";

import PersonalizedLoan from "./PersonalizedLoan";
import { Helmet } from "react-helmet-async";

function RecommendationGmnesq1() {
  return (
    <>
      <Helmet>
        <title>Your Loan Recommendations - Minemi</title>{" "}
      </Helmet>
      <PersonalizedLoan />
    </>
  );
}

export default RecommendationGmnesq1;
